import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModuleErrorPage } from '../../module-error-page';
import { ErrorReport } from '../../error-report';
import { StringUtil } from '@nomidio/common';

@Component({
    selector: 'nom-error-list-item',
    templateUrl: './error-list-item.component.html',
    styleUrls: ['./error-list-item.component.scss'],
    standalone: false
})
export class ErrorListItemComponent {
  @Input()
  public report!: ErrorReport;

  @Output()
  public dismissed = new EventEmitter<ErrorReport>();

  /**
   * Inspect this error.
   */
  public view(): void {
    new ModuleErrorPage(this.report).create({
      title: `Inspector (#${this.report.ordinal})`,
      close: true,
    });
  }

  /**
   * Get the text to display on the page, if any.
   * @returns The text to display.
   */
   public getDisplayText(): string {
    const text = this.report.error?.toString();
    const limit = 192;
    return StringUtil.truncate(text, limit);
  }

  /**
   * Dismiss this error from the display.
   */
  public dismiss(): void {
    this.dismissed.emit(this.report);
  }
}
